import React from "react";
import Flickity from "react-flickity-component";
import "./style.css";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useNavigate } from "react-router";
import { MOVIE_DETAILS_PAGE } from "../../../routes";
import getId from "../../../../utils/getId";
import { ShowSave } from "../../../models/ShowSave";

const flickityOptions = {
  initialIndex: 2,
  wrapAround: true,
  freeScroll: true,
  pageDots: false,
  autoPlay: true,
  pauseAutoPlayOnHover: true,
  adaptiveHeight: true,
  selectedAttraction: 0.01,
  friction: 0.25,
  setGallerySize: false,
  resize: true,
  cellAlign: "center",
  percentPosition: false,
  contain: true,
};

interface IProps {
  movieList: ShowSave[];
}

const CarouselMovie: React.FC<IProps> = ({ movieList }: IProps) => {
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  const handleMovieDetails = (ids: string) => {
    navigate(`${MOVIE_DETAILS_PAGE}?ids=${ids}`);
  };

  return (
    <Flickity options={flickityOptions} className={isDesktop ? "carousel" : "carousel-mobile"}>
      {movieList.map((item, index) => (
        <div className={"carousel-cell"} key={index}>
          <img src={item.moviePicture} alt={item.name} />
          <button className={"btn-movie-name"} onClick={() => handleMovieDetails(getId(item))}>
            {item.name}
          </button>
          <button className={"btn-check"} onClick={() => handleMovieDetails(getId(item))}>
            Wybierz
          </button>
        </div>
      ))}
    </Flickity>
  );
};

export default CarouselMovie;
